import { Building2 } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const workflowTaskExecutionContextOptions: ComboboxFilterOption<string>[] = [
  { label: 'Thatch', value: 'thatch' },
  { label: 'Member', value: 'member' },
]

const WorkflowTaskExecutionContextFilter = (
  props: MultipleSelectedValuesFilter
) => {
  const [query, setQuery] = useState('')

  const filteredOptions = workflowTaskExecutionContextOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          {
            groupLabel: 'Execution Context',
            options: filteredOptions || [],
          },
        ]}
        placeholder='Search execution contexts to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={workflowTaskExecutionContextOptions || []}
          noSelectionText='Execution Context'
          pluralIdentifier='execution contexts'
        >
          <Building2 size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowTaskExecutionContextFilter
